import { type PropsWithChildren, createContext, useContext } from 'react'
import { type FilterEditorStore } from 'widgets/FilterEditor/store/FilterEditorStore'

const FilterEditorContext = createContext<FilterEditorStore | null>(null)

export const useFilterEditorContext = () => {
  const context = useContext(FilterEditorContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with FilterEditorProvider')

  return context
}

export const FilterEditorProvider = ({
  store,
  children,
}: PropsWithChildren<{ store: FilterEditorStore }>) => {
  return <FilterEditorContext.Provider value={store}>{children}</FilterEditorContext.Provider>
}
